import { MultiStepFormState } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form-item';
import {
  MultiStepFormProvider,
  SubmitHandlerWithDirtyFields,
} from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { DeleteTokenModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/inputs/token/delete-token.model';
import { SubmitErrorHandler } from 'react-hook-form';

import { TokenDeleteFormStep1Controller } from '@app/feature/token/token-delete/token-delete-form-step-1/token-delete-form-step-1.controller';
import { useDeleteTokenContext } from '@app/feature/token/token.context';

export interface TokenDeleteFormControllerProps {
  onError: SubmitErrorHandler<Pick<DeleteTokenModel, 'id'>>;
  onSubmit: SubmitHandlerWithDirtyFields<Pick<DeleteTokenModel, 'id'>>;
  onCancel: () => void;
  state: MultiStepFormState;
}

export const TokenDeleteFormController = (
  props: TokenDeleteFormControllerProps,
): React.JSX.Element => {
  const { onError, onSubmit, onCancel, state } = props;
  const data = useDeleteTokenContext();

  return (
    <MultiStepFormProvider<Pick<DeleteTokenModel, 'id'>>
      useFormProps={{
        mode: 'all',
        defaultValues: data,
      }}
      submitErrorHandler={onError}
      submitHandler={onSubmit}
      onCancel={onCancel}
      state={state}
      items={[
        {
          fields: ['id'],
          component: <TokenDeleteFormStep1Controller />,
        },
      ]}
    />
  );
};
